export function convertTimestampToCzech(timestamp, hour_and_minute = false, second = false) {
  if(!timestamp){
    return ""
  }

  var options = {year: 'numeric', month: 'numeric', day: 'numeric'};
  if(hour_and_minute){
    options.hour = '2-digit'
    options.minute = '2-digit'
  }
  if (second){
    options.second = '2-digit'
  } 
  const date = new Date(timestamp)
  return date.toLocaleDateString('cs-CZ', options);
}

export function tsToDateObjectOnlyDay(isoDateString) {
  const date = new Date(isoDateString);
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}

export function toEpoch(isoDateString) {
  const date = new Date(isoDateString);
  const epochTime = date.getTime();
  return epochTime;
}

export function strTsToStrDate(isoDateString) {
  const date = new Date(isoDateString);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // January is 0!
  const year = date.getUTCFullYear();
  return `${year}-${month}-${day}`;
}

export function dateObjToStrDate(in_date) {
  let date = new Date(in_date);
  date.setDate(in_date.getDate() + 1);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // January is 0!
  const year = date.getUTCFullYear();
  return `${year}-${month}-${day}`;
}

export function getDatesBetween(startDate, endDate) {
  let dates = {};
  let currentDate = new Date(startDate);
  let endDateConverted = new Date(endDate);
  currentDate.setDate(currentDate.getDate() + 1);
  endDateConverted.setDate(endDateConverted.getDate() + 1);
  while (currentDate <= endDateConverted) {
    let formattedDate = currentDate.toISOString().split("T")[0];
    dates[formattedDate] = 0;
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dates;
}

export function getTimestamp30DaysAgo() {
  const date = new Date();
  date.setDate(date.getDate() - 30);
  return date.toISOString();
}

export function getTimestampToday() {
  const date = new Date();
  return date.toISOString();
}

export function switchDateFormat(dateStr) {
  // Split the date string into [YYYY, MM, DD]
  let parts = dateStr.split("-");

  // Reorder the parts as [YYYY, DD, MM]
  let reorderedParts = [parts[0], parts[2], parts[1]];

  // Join the parts into a string in the format YYYY-DD-MM
  return reorderedParts.join("-");
}

export function convertISOToReadableFormat(isoString) {
  if (isoString === null) {
    return "";
  }
  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed in JavaScript
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function validateBirthDate(b_date) {
  if (isNaN(b_date.getTime())) {
    return false;
}
  const min_date = new Date("1900-01-01");
  const max_date = new Date();
  let o = true;
  if (b_date.getTime() < min_date.getTime()) {
    o = false;
  } else if (b_date.getTime() >= max_date.getTime()) {
    o = false;
  }
  return o;
}



export function trucateSecondsFromIsoString(isoString) {
  return isoString.slice(0, 16);
}

function toIsoStringWTimeZone(date) {
  var tzo = -date.getTimezoneOffset(),
      dif = tzo >= 0 ? '+' : '-',
      pad = function(num) {
          return (num < 10 ? '0' : '') + num;
      };

  return date.getFullYear() +
      '-' + pad(date.getMonth() + 1) +
      '-' + pad(date.getDate()) +
      'T' + pad(date.getHours()) +
      ':' + pad(date.getMinutes()) +
      ':' + pad(date.getSeconds()) +
      dif + pad(Math.floor(Math.abs(tzo) / 60)) +
      ':' + pad(Math.abs(tzo) % 60);
}

export function toIsoStringWTimeZoneWOSeconds(date){
  return(
    trucateSecondsFromIsoString(toIsoStringWTimeZone(date))
  )
}